var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-md-8 text-center"},[_c('img',{attrs:{"src":require("@/assets/img/404.png"),"alt":""}}),_c('h2',[_vm._v("\n      "+_vm._s(_vm.$t("pages.notFound.title"))+"\n    ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }